import React from "react";
import { TickSquare, CloseSquare } from "iconsax-react";
import CommonTable from "../../../Components/CommonTable";
import dayjs from "dayjs";

const CorrectionRequests = ({
  data,
  nextPageUrl,
  prevPageUrl,
  onPageChange,
  totalCount,
  page,
}) => {
  return (
    <>
      <div className="flex flex-col gap-4 md:hidden">
        {data?.results?.map((item) => (
          <div
            key={item.request_id}
            className="w-full border border-gray-200 rounded-lg bg-white p-4 flex flex-col gap-3"
          >
            <div>
              <p className="text-xs text-gray-500">Request ID</p>
              <p className="text-sm font-medium text-gray-800">{item.empId}</p>
            </div>

            <div className="grid grid-cols-2 gap-y-3 gap-x-6">
              <div>
                <p className="text-xs text-gray-500">Name</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.employee_name}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Check In correction</p>
                <p className="text-sm font-medium text-gray-800">
                  { dayjs(item.current_check_in).format("hh:mm A")}{ item?.requested_check_in ? " - " + dayjs(item.requested_check_in).format("hh:mm A") : " " }
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Check Out Correction</p>
                <p className="text-sm font-medium text-gray-800 truncate">
                  { dayjs(item.current_check_out).format("hh:mm A")}{item.requested_check_out? " - " + dayjs(item.requested_check_out).format("hh:mm A") : " "}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Date</p>
                <p className="text-sm font-medium text-gray-800">
                  { dayjs("2026-10-07T10:01:00+05:30").format("hh:mm A") || dayjs(item?.attendance_date).format("hh:mm A")}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Approved By</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.approved_by || "— — — —"}
                </p>
              </div>

              <div>
                <button className="px-10 py-2 p-2 bg-[#00B8D9] text-white rounded-xl text-bold">
                  View
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="hidden md:block">
        <CommonTable
          data={data?.results || []}
          rowKey="request_id"
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          onPageChange={onPageChange}
          totalCount={totalCount}
          page={page}
          columns={[
            { key: "employee_id", label: "Employee Id" },
            { key: "employee_name", label: "Name" }, 
            { key: "attendance_date", label: "Date" },
            {
              key: "current_check_in",
              label: "Check In Request",
              render: (v, row) => `${dayjs(v).format("hh:mm A")}  ${ row.current_check_in ? " - " + dayjs(row.requested_check_in).format("hh:mm A") : " "}`,
            },
            {
              key: "current_check_out",
              label: "Check Out Request",
              render: (v, row) => ` ${dayjs(v).format("hh:mm A")} ${row.current_check_out ? " - " + dayjs(row.requested_check_out).format("hh:mm A") : " "}`,
            },
            { key: "approved_by", label: "Approved By" },
          ]}
          rowActions={(row) =>
            row.actions ? (
              <div className="flex items-center justify-center gap-2">
                <TickSquare size="20" color="#166534" variant="Bold" />
                <CloseSquare size="20" color="#ef4444" variant="Bold" />
              </div>
            ) : (
              <span className="text-gray-500 font-medium">{row.status}</span>
            )
          }
        />
      </div>
    </>
  );
};

export default CorrectionRequests;
